var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9323 14.9109L16.6699 14.6526C16.1266 14.5902 15.5922 14.7772 15.2092 15.1602L13.5703 16.7991C11.0497 15.5165 8.98334 13.459 7.70076 10.9295L9.34852 9.28174C9.73151 8.89875 9.91855 8.36434 9.85621 7.82102L9.59791 5.57651C9.49103 4.67692 8.73395 4 7.82545 4H6.28457C5.2781 4 4.44086 4.83724 4.50321 5.84371C4.97527 13.4501 11.0586 19.5246 18.6561 19.9966C19.6626 20.059 20.4999 19.2218 20.4999 18.2153V16.6744C20.5088 15.7748 19.8318 15.0177 18.9323 14.9109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.74fe0b669f44853931eecef366c5be4b.svg";
export { ForwardRef as ReactComponent };